<template>
  <div class="org-home">
    <OrganizationInfo view="full" :organization="organization" />
  </div>
</template>

<script>
import OrganizationInfo from "@/components/OrganizationInfo";
import { meta } from "@/libs/mixins";

export default {
    name: "OrganizationHome",

    props: ["slug", "organization"],

    components: { OrganizationInfo },
    
    mixins: [meta],

    metaInfo() {
        return this.getMetaInfo({
            title: `${ this.organization.name }`,
        });
    }, 

};
</script>
